import { BannerStatus } from './banner';
import { BenefitsStatus } from './benefits';
import { ProductStoreStatus } from './product-store';

export enum PartnerActionsType {
  BENEFIT = 'BENEFIT',
  PRODUCT = 'PRODUCT',
  BANNER = 'BANNER',
}

export type PartnerAction = {
  uuid: string;
  partner_uuid: string;
  partner_name: string;
  action_type: PartnerActionsType;
  status: ProductStoreStatus | BannerStatus | BenefitsStatus;
  description: string;
  start_date: string;
  end_date: string;
  created_at: string;
  updated_at: string;
};

export const translatePartnerActionType = (type: PartnerActionsType): string => {
  switch (type) {
    case PartnerActionsType.BENEFIT:
      return 'Clube de Benefícios';
    case PartnerActionsType.PRODUCT:
      return 'Produto na Loja';
    case PartnerActionsType.BANNER:
      return 'Banner na Home';
    default:
      return type;
  }
};

export const colorByPartnerActionStatus: Record<ProductStoreStatus | BannerStatus | BenefitsStatus, string> = {
  [ProductStoreStatus.PUBLISHED]: 'green.500',
  [ProductStoreStatus.NOT_PUBLISHED]: 'gray.500',
  [ProductStoreStatus.DRAFT]: 'gray.500',
  [ProductStoreStatus.DELETED]: 'red.500',
  [ProductStoreStatus.SCHEDULED]: 'yellow.500',
  [BannerStatus.ENABLED]: 'green.500',
  [BenefitsStatus.DISABLED]: 'red.500',
};

export const translatePartnerActionStatus = (status: ProductStoreStatus | BannerStatus | BenefitsStatus): string => {
  switch (status) {
    case ProductStoreStatus.PUBLISHED:
      return 'Publicado';
    case ProductStoreStatus.NOT_PUBLISHED:
      return 'Não Publicado';
    case ProductStoreStatus.DRAFT:
      return 'Rascunho';
    case ProductStoreStatus.DELETED:
      return 'Excluído';
    case ProductStoreStatus.SCHEDULED:
      return 'Agendado';
    case BannerStatus.ENABLED:
      return 'Ativo';
    case BenefitsStatus.DISABLED:
      return 'Desativado';
    default:
      return status;
  }
};
